// extracted by mini-css-extract-plugin
export default {"pagination":"pagination--l-Gy8ktwh0","loader":"loader--KqH8yIjtOt","display":"display--ohVYQZNnbn","inputContainer":"inputContainer--AhLKA10d4U"};